import { createElement } from 'react';

import { AuthHelper } from '@shared/auth/AuthHelper';
import { initializeLocalization } from '@shared/i18n';
import { AppInsights, setupLogging } from '@shared/logging/appInsights';
import { logError } from '@shared/logging/logging';
import { setupSpartaApi } from '@shared/spartaApiPicker';
import { rootElement } from '@shared/startup';

try {
	window.__$ver = `build: ${__$buildNumber} | build time: ${__$buildTime}`;

	setupLogging();
	AppInsights.trackPageView();

	setupSpartaApi();

	const locPromise = initializeLocalization();

	const renderAuthFailure = async () => {
		await locPromise;
		const { AuthFailure } = await import(/* webpackChunkName: "AuthFailure" */ '@shared/components/AuthFailure/AuthFailure');
		rootElement.render(createElement(AuthFailure));
	};

	// Note: Boot is intentionally imported after locPromise resolves to avoid issues with delayed string loading.
	const bootImport = locPromise.then(async () => import(/* webpackChunkName: "PlatformBoot" */ './boot'));

	AuthHelper.initialize(
		{ tenantName: window.siteConfig.tenantName, tenantId: window.siteConfig.tenantId },
		async (user) => {
			try {
				// wait for localization to finish initialization before rendering anything
				await locPromise;

				const { boot } = await bootImport;
				boot(user);
			} catch (e) {
				logError(e);
				await AuthHelper.redirectToLogin();
			}
		},
		renderAuthFailure,
	);
} catch (e) {
	logError(e);
}
